// useCreateContractorDm (issue #419) — POST /chats/jobs/:jobId/contractors/
// :contractorId/direct.
//
// Lead/admin opens a DM with a specific assigned contractor. Idempotent on
// the server via `dedupeKey`.

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createContractorDm } from './api';
import { chatKeys } from './keys';

import type { Chat } from 'src/models/chat';

interface Args {
  jobId: number;
  contractorId: number;
}

export function useCreateContractorDm() {
  const queryClient = useQueryClient();
  return useMutation<Chat, unknown, Args>(
    ({ jobId, contractorId }) => createContractorDm(jobId, contractorId),
    {
      onSuccess: (_chat, { jobId }) => {
        queryClient.invalidateQueries(chatKeys.myChatsRoot());
        queryClient.invalidateQueries(chatKeys.jobChats(jobId));
      },
    }
  );
}
